import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { User } from '../User';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { ApiService } from '../api.service';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { AlertService } from '../alert.service';
import { HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { ModalDirective } from 'angular-bootstrap-md';
import { debug } from 'util';
import { DatePipe, getLocaleDayNames } from '@angular/common';
import * as moment from 'moment';
//import { userInfo } from 'os';

 
class signUpUserObj {
  fName: string = "";
  lName: string = "";
  gender: number = 1;
  signUpType: "generic";
  mobile: string = "";
  email: string = "";
  password: string = "";
}

class signinUsrObj {
  username: string = "";
  password: string = "";
}



@Component({
  selector: 'app-bike-selection',
  templateUrl: './bike-selection.component.html',
  styleUrls: ['./bike-selection.component.scss']
})
export class BikeSelectionComponent implements OnInit {
  @ViewChild('OTPModal') OTPModal: ModalDirective;
  @ViewChild('ongoingError') ongoingError: ModalDirective;
  @ViewChild('forgotPasswordModal') forgotPasswordModal: ModalDirective;
  @ViewChild('changePlanModal') changePlanModal: ModalDirective;
  @ViewChild('paymentProceed') paymentGatewayProceed: ModalDirective;
  @ViewChild('paymentProceedDirect') paymentGatewayProceedDirect: ModalDirective;

  selecetdId: number;
  buttonText: string = "";
  debugData: Boolean = false; // to show and hide the console log messages
  private user: User;  // to store the vlues of user object return from server
  private userSignUpData: signUpUserObj; // to store the values of signup form
  private userSigninData: signinUsrObj; // to store values of signin form data
  otpErrorMsg: string = ""; // to display the error msg on otp popup
  emailResetMsg: string = ""; // to display the error msg in email reset popup
  SignUpmsg: string = ""; // to display the signup msg in signup form html
  SignInmsg: string = ""; // to display the error msg in sign in form html
  addressUpdateMsg: string = ""; // to display the error msg in the adress update form html
  uerDlUpdateMsg: string = "";//to display the error msg in DL uplate
  selectedMonths: number = 0; // to get the selected month by the user in previous page
  availablePoints: number = 0; // to store the points of customer if logged in
  ongoing_error_msg: string = ""; // show error msg when already ongoing is booking running
  ongoingErrorMsg: string = ""; //show error message if alredy have ongoing booking
  show1: boolean = false;
  show2: boolean = true;
  public ongoingData: any = [];
  public getCompExprDetail: any = [];

  subscription_plan_list = [
    { "id": 1, "month": 1, "effective_rental": 3500, "wallet": 130 },
    { "id": 2, "month": 2, "effective_rental": 3350, "wallet": 170 },
    { "id": 3, "month": 3, "effective_rental": 3330, "wallet": 205 },
    { "id": 4, "month": 4, "effective_rental": 3295, "wallet": 245 },
    { "id": 5, "month": 5, "effective_rental": 3255, "wallet": 280 },
    { "id": 6, "month": 6, "effective_rental": 3220, "wallet": 320 },
    { "id": 7, "month": 7, "effective_rental": 3180, "wallet": 360 },
    { "id": 8, "month": 8, "effective_rental": 3140, "wallet": 395 },
    { "id": 9, "month": 9, "effective_rental": 3105, "wallet": 435 },
    { "id": 10, "month": 10, "effective_rental": 3065, "wallet": 475 },
    { "id": 11, "month": 11, "effective_rental": 3025, "wallet": 510 },
    { "id": 12, "month": 12, "effective_rental": 2990, "wallet": 0 }
  ];
  // setting base url for payment surl and furl
  baseUrl: any;


  public show: boolean = true;
  public buttonName: any = 'Login';

  loginAlert: string;
  loginError: boolean = false;

  toggle() {
    this.show1 = !this.show1;
  }

  toggleH() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.buttonName = "Login";
    else
      this.buttonName = "Sign Up";
  }

  //data: Observable<Array<any>>;
  divs: Array<any> = ["Menu1", "Menu2"];
  visibleDivId: number = null;
 
  location: Array<any> = []; // to keep the values of pickup location from server

  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private alertService: AlertService, private apiService: ApiService, private datePipe: DatePipe
  ) {
    this.user = new User();
    this.initCustData();
    this.userSigninData = new signinUsrObj();
    this.userSignUpData = new signUpUserObj();
    if (this.debugData == true) {
      console.log("Constructor init SignIn and SignUp object");
      console.log(this.userSigninData);
      console.log(this.userSignUpData);
    }
      this.baseUrl = 'https://api.on-track.in';
   // this.baseUrl = 'http://159.65.154.92';
    // if (window.location.hostname == 'localhost')
    //   // this.baseUrl='http://127.0.0.1:1337';
    //   this.baseUrl = 'https://api.on-track.in';
    // else
    //   this.baseUrl = window.location.origin;
    this.route.paramMap.subscribe(
      params => {
        this.selecetdId = +params.get('id');
        this.selectedMonths = +params.get('months');
        if (this.debugData) {
          console.log("user slected for bike and month");
          console.log("Model Id:" + this.selecetdId);
          console.log("months Plan:" + this.selectedMonths);
        }
        this.checkMonthValid(this.selectedMonths);
        //this.data = apiService.get('getModelDetailsById?id=' + this.selecetdId);
        //this.data1 = return this.httpClient.get(this.url2 +'getModelDetailsById?id=',{this.selecetdId})
      }
    );
  }

  modelDataToShow: Array<any> = []; // to show the data into ui part
  modelDataOriginal: Array<any> = []; // to show the data into ui part
  selectedMonthsVal: number = 0; // tp show the selected month in ui from previous page

  checkMonthValid(moths: number) {
    if ((moths == 1) || (moths == 3) || (moths == 6) || (moths == 12)) {
      this.selectedMonthsVal = moths;
      //this.modelDataOriginal[0].price = 0;
      this.initModelDataToProcess();
      this.initModelData(moths);
    } else {
      this.router.navigate(['/404'])
    }
  }

  // function to get the data and to store it for the further process values
  initModelDataToProcess() {
    this.apiService.get('getModelDetailsById?id=' + this.selecetdId)
      .subscribe(dataa => {
        this.modelDataOriginal = dataa.slice(); // for the deep copy of value to the new json array
      });
  }

  // function to fetch and show the plan data from server in each click of plan.
  initModelData(months: number) {
    this.selectedMonthsVal = months;
    if (this.debugData == true) {
      console.log("Months Selected");
      console.log(this.selectedMonthsVal);
    }

    this.apiService.get('getModelDetailsById?id=' + this.selecetdId)
      .subscribe(dataa => {
        if (this.debugData) {
          console.log("Model get API data");
          console.log(dataa);
        }
        this.modelDataToShow = dataa; // for copying the value to the next element
        if (this.modelDataToShow.length != 0) {
          this.showRentalSubscriptionPlan(this.modelDataToShow[0].price);
          this.jsonDataArray(months);
        } else {
          this.error("Error loading page! Please refresh.");
        }
      });
  }


  // setting up monthly subscription data
  jsonDataArray(months) {
    let monthlyDiscountPercent = [3.64, 4.73, 5.82, 6.91, 8.00, 9.09, 10.18, 11.27, 12.36, 13.45, 14.55];
    let temp = this.modelDataToShow;

    if (months == 1) {
      this.modelDataToShow = temp;
    } else if (months == 3) {
      let tempVals = 0;
      for (let i = 0; i < 2; i++) {
        tempVals += Number(((this.modelDataToShow[0].price * monthlyDiscountPercent[i]) / 100).toFixed(2));
      }
      this.modelDataToShow[0].price = this.modelDataToShow[0].price - Number((tempVals / 3).toFixed(0));
      console.log(this.modelDataToShow[0].price);
    } else if (months == 6) {
      let tempVals = 0;
      for (let i = 0; i < 5; i++) {
        tempVals += Number(((this.modelDataToShow[0].price * monthlyDiscountPercent[i]) / 100).toFixed(2));
      }
      this.modelDataToShow[0].price = this.modelDataToShow[0].price - Number((tempVals / 6).toFixed(0));
    } else if (months == 12) {
      let tempVals = 0;
      for (let i = 0; i < 11; i++) {
        tempVals += Number(((this.modelDataToShow[0].price * monthlyDiscountPercent[i]) / 100).toFixed(2));
      }
      this.modelDataToShow[0].price = this.modelDataToShow[0].price - Number((tempVals / 12).toFixed(0));
    }

    this.modelDataToShow = temp;
    this.totalPyamentPrice = this.modelDataOriginal[0].price;
    this.getTotalPrice();
  }
  
 

  // get pickup location from url
  getPickuplocation() {
    if (this.debugData == true) {
      console.log("Pickup Locatin Function executed");
    }
    this.httpClient.get(this.apiService.GET_PICKUP_LOCATION_URL)
      .subscribe(
        (pickup_detail: any) => {
          if (this.debugData == true) {
            console.log("Pickup Locatin API Data");
            console.log(pickup_detail);
          }
          this.location = pickup_detail;
        }
      )
  }

  ngOnInit() {

  }

  // getting the customer data from url
  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      this.checkDocumentNullState = this.checkDocumentNull();
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.initCompUrl(data),
          error => this.showError(error)
        );
    } else {
      console.log("User Not Logged In. Please login!")
    }
  }

  initCompUrl(data) {
    this.intilizeComponent(data);
    this.checkDocumentNullState = this.checkDocumentNull();
  }

  intilizeComponent(data) {
    this.user = data;
    if (this.debugData) {
      console.log("User Object Data is");
      console.log(this.user);
    }
    this.getPickuplocation();
    this.getCustomerPoints();
    //this.getOngoing();
    this.getBookingExpireCompleted();
   
  }

  getBookingExpireCompleted() {
    let getDATA = { "Customer": this.user.id, "status": 5 }
    this.httpClient.post(this.apiService.getBookingBYquery, getDATA)
      .subscribe(
        (data_detail: any) => {
          if (this.debugData) {
            console.log("Get Expire Completed Booking API Data");
            console.log(data_detail);
          }
          this.getCompExprDetail = data_detail;
          //console.log(this.getCompExprDetail[0].rentalCharge);
          this.totalNoofDays();
        }
      )
  }
  //no of days
  // this.getCompExprDetail
  availablePointss: number = 0; // to display and hold available points
  helMetPriceUi: number = 0; // to display the price of rental helmet charge in ui
  monthlyRentalChargeUi: number = 0; // to display the price of rental helmet charge in ui
  noOfDaysUI: number = 0; // to display the noOfDays of rent in ui
  newEndDateUi: string = "";
  totalPriceToPayUi: number = 0;
  finalAmount: number = 0; //final Amount which willl go to the payment gateway after having everything
  penalityChargeUi: number = 0;
  public points: number = 0;
 // usePoints: boolean = false; // to get to know customer is using the points or not
  totalNoofDays()
  {
   

    this.availablePointss = this.points;
    //this.noOfDaysUI = noOfDay;
    this.noOfDaysUI = this.user.penaltyCharge/100;
    //console.log(this.noOfDaysUI);
    this.penalityChargeUi = this.user.penaltyCharge;
    // let tempArray = this.getCompExprDetail[0].endDate.split('T');
    // let StartDateObj = new Date(tempArray[0]);
    // StartDateObj.setDate(StartDateObj.getDate() + this.noOfDaysUI);
    // this.newEndDateUi = this.datePipe.transform(StartDateObj, 'dd/MM/yyyy');
    //console.log(this.getCompExprDetail[0]);
    let helmentChargeValue = 0;
    let DaysHelmetCharge = 0;
    let DaysRentalCharge = 0;
    let DayTotalPrice = 0;
    let modelPriceValue = this.getCompExprDetail[0].rentalCharge;

    if (this.getCompExprDetail[0].extraHelmet == true) {
      helmentChargeValue = 50;
    }
    else {
      helmentChargeValue = 0;
    }

    if (this.noOfDaysUI <= 7) {
      DaysRentalCharge = ((modelPriceValue) + ((modelPriceValue * 20) / 100));
      DaysRentalCharge = ((DaysRentalCharge / 30) * this.noOfDaysUI);

      DaysHelmetCharge = ((helmentChargeValue) + ((helmentChargeValue * 20) / 100));
      DaysHelmetCharge = ((DaysHelmetCharge / 30) * this.noOfDaysUI);
    } else if (this.noOfDaysUI >= 8 && this.noOfDaysUI < 16) {
      DaysRentalCharge = ((modelPriceValue) + ((modelPriceValue * 15) / 100));
      DaysRentalCharge = ((DaysRentalCharge / 30) * this.noOfDaysUI);

      DaysHelmetCharge = ((helmentChargeValue) + ((helmentChargeValue * 15) / 100));
      DaysHelmetCharge = ((DaysHelmetCharge / 30) * this.noOfDaysUI);
    } else if (this.noOfDaysUI >= 16) {
      DaysRentalCharge = ((modelPriceValue) + ((modelPriceValue * 10) / 100));
      DaysRentalCharge = ((DaysRentalCharge / 30) * this.noOfDaysUI);

      DaysHelmetCharge = ((helmentChargeValue) + ((helmentChargeValue * 10) / 100));
      DaysHelmetCharge = ((DaysHelmetCharge / 30) * this.noOfDaysUI);
    }

    DayTotalPrice = Number(DaysRentalCharge.toFixed(2)) + Number(DaysHelmetCharge.toFixed(2));
    console.log("hiiiii")
    console.log(DayTotalPrice);

    DayTotalPrice = Number(DaysRentalCharge.toFixed(2)) + Number(DaysHelmetCharge.toFixed(2));
    this.helMetPriceUi = Number(DaysHelmetCharge.toFixed(2));
    this.monthlyRentalChargeUi = Number(DaysRentalCharge.toFixed(2));
    this.totalPriceToPayUi = Number(DayTotalPrice.toFixed(2));
    console.log(this.totalPriceToPayUi);

    if (DaysRentalCharge >= modelPriceValue) {
      DaysRentalCharge = modelPriceValue;
      this.monthlyRentalChargeUi = DaysRentalCharge;
    }

    if (DaysHelmetCharge >= helmentChargeValue) {
      DaysHelmetCharge = helmentChargeValue;
      this.helMetPriceUi = DaysHelmetCharge;
    }

    if (DayTotalPrice >= (modelPriceValue + helmentChargeValue)) {
      DayTotalPrice = modelPriceValue + helmentChargeValue;
      this.totalPriceToPayUi = DayTotalPrice
      console.log("day price");
      console.log(this.totalPriceToPayUi);
    }

    // if (this.user.penaltyCharge != 0) {
    //   this.totalPriceToPayUi += this.user.penaltyCharge;
    // }


    if (this.usePoints == true) {
      this.finalAmount = this.totalPriceToPayUi - this.availablePoints;
      if (this.finalAmount < 1) {
        this.finalAmount = 0;
      }
    } else {
      this.finalAmount = this.totalPriceToPayUi;
      console.log("final_penalty_rental");
      console.log(this.finalAmount);
    }
  }
  //end no of days


  checkUserLoginStatus(): boolean {
    if (this.apiService.checkUserLoggedIn() == true) {
      return true;
    } else {
      return false;
    }
  }

  showError(msg) {
    console.log("Error Found in server");
  }

  // start of setting up effective rental list
  showRentalSubscriptionPlan(BikePrice) {
    let monthlyDiscountPercent = [3.64, 4.73, 5.82, 6.91, 8.00, 9.09, 10.18, 11.27, 12.36, 13.45, 14.55, 0];

    for (let i = 0; i < monthlyDiscountPercent.length; i++) {
      this.subscription_plan_list[i].wallet = Number(((BikePrice * monthlyDiscountPercent[i]) / 100).toFixed(0));
      if (i == 0) {
        this.subscription_plan_list[0].effective_rental = BikePrice
      } else {
        this.subscription_plan_list[i].effective_rental = BikePrice - this.subscription_plan_list[i - 1].wallet;
      }

    }
  }
  // End of setting up effective rental list


  // <!-- Start of sign in function -->
  public onFormLogin({ value, valid }: { value: signinUsrObj, valid: boolean }) {
    this.userSigninData = value;
    if (this.debugData) {
      console.log("Sign In Function data")
      console.log(this.userSigninData);
    }
    this.httpClient.post(this.apiService.LoginURL, this.userSigninData)
      .subscribe((data: any) => {
        if (this.debugData == true) {
          console.log("Customer Login API data");
          console.log(data);
        }
        if (data.success == "true") {
          if (this.debugData == true) {
            console.log("Customer id : " + data.customer.id);
            console.log("Customer Name : " + data.customer.fName);
          }
          //this.success("Successfully logged in");
          this.SignInmsg = "Sign In Sucessfull";
          this.storage.set('custDD', data.customer.id);
          this.storage.set('Name', data.customer.fName);
          this.refresh();
        } else {
          //this.success("Login failed");
          this.SignInmsg = " Sign in failed try again";
        }
      });
  }
  // <!-- End of sign in function -->

  genderNow: number = 1; // 1 for male and 0 for female , by default keep it as male
  changeGender(valueGender: number) {
    this.genderNow = valueGender;
    if (this.debugData) {
      console.log("Selected gender is ");
      console.log(this.genderNow);
    }
  }

  // <!-- Start of sign up function -->
  public onFormSubmit({ value, valid }: { value: signUpUserObj, valid: boolean }) {
    this.userSignUpData = value;
    this.userSignUpData.signUpType = "generic";
    if (this.debugData) {
      console.log("User SignUp Data");
      console.log(this.userSignUpData);
    }
    this.httpClient.post(this.apiService.signupURL, this.userSignUpData)
      .subscribe(
        (dataSignup: any) => {
          if (this.debugData) {
            console.log("signup form function api data");
            console.log(dataSignup);
          }
          if (dataSignup.status == true) {
            this.SignUpmsg = "Signup Successfully";
            this.user = dataSignup.obj;
            this.storage.set('custDD', this.user.id);
            this.storage.set('Name', this.user.fName);
            this.buttonText = this.user.fName;
            this.OTPModal.show();
          } else {
            this.SignUpmsg = "Some Error Occured Please try again";
          }
        },
        (err) => {
          let errorD = err.error.message;
          if (errorD.indexOf("mobile") != -1) {
            this.SignUpmsg = "Mobile number already exist";
          } else if (errorD.indexOf("email") != -1) {
            this.SignUpmsg = "Email address already exist";
          }
        });
  }
  // <!-- end of sign up function -->

  // <!-- start of OTP verify function  -->
  verifyOtpN(otpToVerify) {
    let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
    if (this.debugData) {
      console.log("very otp json data is ")
      console.log(postData);
    }
    this.httpClient.post(this.apiService.verifyOTP_URL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("very otp function API Data ")
            console.log(detail);
          }
          if (detail.status == true) {
            if (this.debugData) {
              console.log("Success OTP Verified")
            }
            this.user = detail.obj;
            this.otpErrorMsg = "OTP Verified";
            this.refresh();
          } else {
            if (this.debugData) {
              console.log(" OTP not Verified")
            }
            this.otpErrorMsg = "Incorrect OTP";
          }
        }
      )
  }
  // <!-- end of OTP verify function  -->



  // <!-- Start of OTP send function  -->
  sendOtpN(mobileNumber, custId) {
    let postData = { 'mobile': mobileNumber, 'id': custId };
    this.httpClient.post(this.apiService.sendOtpURL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("Send OTP Api data");
            console.log(detail);
          }
          if (detail.status == true) {
            return true;
          } else {
            return false;
          }
        }
      )
  }
  // <!-- end of OTP send function  -->

  // <!-- start of OTP Resend function  -->
  resendOtpNow() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let postData = { 'mobile': this.user.mobile };
      this.httpClient.post(this.apiService.resendURL, postData)
        .subscribe(
          (detail: any) => {
            if (this.debugData) {
              console.log("resend otp function API data");
              console.log(detail);
            }
            if (detail.status == true) {
              this.otpErrorMsg = "OTP sent"
            } else {
              this.otpErrorMsg = "OTP sending fail"
            }
          },
          (err) => {
            this.otpErrorMsg = "Some error occured. Please try again."
          });
    } else {
      this.warn("Please Login");
    }
  }
  // <!-- end of OTP Resend function  -->


  // checkAddressNull(): boolean {
  //   if ((this.user.address === null) || (this.user.address === "")
  //     || (this.user.city === null) || (this.user.city === "")
  //     || (this.user.state === null) || (this.user.state === "")
  //     || (this.user.pinCode === null) || (this.user.pinCode === 0)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  //--------add user DL Number
  addUserDlnumber(dlUser) {
    let postDLData = { 'DLnumber': dlUser }
    let custid_url = this.apiService.cutomerDetails + this.user.id;
    if (this.debugData) {
      console.log("Add user DL function data ")
      console.log(postDLData);
    }
    this.httpClient.post(custid_url, postDLData)
      .subscribe(
        (data_detail: any) => {
          if (this.debugData) {
            console.log("update DL api data")
            console.log(data_detail)
          }
          this.uerDlUpdateMsg = "DL updated Sucess";
          this.user = data_detail;
        },
        (err) => {
          let errorD = err.error.message;
          if (errorD.indexOf("DLnumber") != -1) {
            this.uerDlUpdateMsg = "DLnumber number already exist";
          }
        });
    // (err) => {
    //   this.uerDlUpdateMsg = "Some error occured. Please try again";
    // });
  }
  //---------end DL number

  checkAddressNull(): boolean {
    if ((!this.user.address) || (!this.user.city) || (!this.user.state) || (!this.user.state)
      || (!this.user.pinCode)) {
      return true;
    } else {
      return false;
    }
  }

  // checkDlNull(): boolean {
  //   if (!this.user.DLnumber) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  checkDocumentNullState: boolean = false;
  checkDocumentNull(): boolean {
    if ((this.user.DLfront == null) || (this.user.DLfront == "") || (this.user.DLback == null) || (this.user.DLback == "")
      || (this.user.idProof == null) || (this.user.idProof == "") || (this.user.DLnumber == null) || (this.user.DLnumber == "")) {
      return true;
    } else {
      return false;
    }
  }

  docUploadErrorMsg: string = "";
  proceedDocumentUpload() {
    this.checkDocumentNullState = this.checkDocumentNull();
    if (this.checkDocumentNullState == true) {
      this.docUploadErrorMsg = "Please upload all documents and DL Number."
    } else {
      this.docUploadErrorMsg = "Document uploaded sucessfully."
    }
  }

  refresh(): void {
    window.location.reload();
  }

  logout() {
    this.storage.remove('custDD');
    this.apiService.saveInLocalData('custDD', null);
    this.apiService.saveInLocalData('custnm', null);
    this.router.navigate(['/model']);
  }

  //<!-- start of reset password function -->
  resetPwd(emailVal: string) {
    let getResetData = { "email": emailVal };
    this.httpClient.post(this.apiService.postsURL + 'resetPassword', getResetData)
      .subscribe(
        (reset: any) => {
          if (this.debugData) {
            console.log("Email Reset function");
            console.log(reset);
          }
          if (reset.status == true) {
            this.emailResetMsg = "Link sent successfully";
            this.forgotPasswordModal.hide();
            return true;
          } else {
            this.emailResetMsg = "Please enter valid email id";
            return false;
          }
        },
        (err) => {
          this.emailResetMsg = "Some error occured. Please try again."
        });
  }
  //<!-- End of reset password function -->


  success(message: string) {
    this.alertService.success(message);
  }

  error(message: string) {
    this.alertService.error(message);
  }

  info(message: string) {
    this.alertService.info(message);
  }

  warn(message: string) {
    this.alertService.warn(message);
  }

  clear() {
    this.alertService.clear();
  }


  toggleVisibility(divId) {
    if (this.visibleDivId === divId) {
      //visibleDivId = null;
    } else {
      this.visibleDivId = divId;
    }
    this.hideNonVisibleDivs();
  }

  hideNonVisibleDivs() {
    let i, divId, div;
    for (i = 0; i < this.divs.length; i++) {
      divId = this.divs[i];
      div = document.getElementById(divId);
      if (this.visibleDivId === divId) {
        div.style.display = "block";
      } else {
        div.style.display = "none";
      }
    }
  }

  addUserAddress(HouseNoUsr, StreetUsr, LocalityUsr, LandmarkUsr, cityUsr, stateUsr, pincodeUsr) {
    //HouseNo Street Locality Landmark  City State Pincode
    let addressUsr = HouseNoUsr + ", " + StreetUsr + ", " + LocalityUsr + ", " + LandmarkUsr;
    let postData = { 'address': addressUsr, 'city': cityUsr, 'state': stateUsr, 'pinCode': pincodeUsr }
    let custid_url = this.apiService.cutomerDetails + this.user.id;
    if (this.debugData) {
      console.log("Add Address function data ")
      console.log(postData);
    }

    this.httpClient.post(custid_url, postData)
      .subscribe(
        (data_detail: any) => {
          if (this.debugData) {
            console.log("update adress api data")
            console.log(data_detail)
          }
          this.addressUpdateMsg = "Adress updated Sucess";
          this.user = data_detail;
          //this.refresh();
        },
        (err) => {
          this.addressUpdateMsg = "Some error occured. Please try again";
        });
  }

  selectedFile: File;
  public dlfront = ""; 
  public dlFrontProgress = 0;
  public dlback = "";
  public dlbackProgress = 0;
  public idproof = "";
  public idproofProgress = 0;
  key: string = 'DLfront';
  key1: string = 'DLback';
  key2: string = 'idProof';
  url1: string;

  //______________________________________________________________________________________________
  // start of document upload//
  onSelectFile(event, idType) { // called each time file input changes
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]); // read file as data url
    this.selectedFile = event.target.files[0];
    reader.onload = (event) => { // called once readAsDataURL is completed
      //console.log("data selected loaded");
      this.onUpload(idType);
    }
  }

  onUpload(idTypeA) {
    let urlUploads = this.apiService.postsURL + 'uploadCustomerDoc?id=' + this.user.id + '&key=' + idTypeA;
    if (idTypeA == 'DLfront') {
      urlUploads += '&old=' + this.dlfront;
    } else if (idTypeA == 'DLback') {
      urlUploads += '&old=' + this.dlback;
    } else if (idTypeA == 'idProof') {
      urlUploads += '&old=' + this.idproof;
    }
    const uploadData = new FormData();
    uploadData.append('image', this.selectedFile, this.selectedFile.name);
    this.httpClient.post(urlUploads, uploadData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe(
      event => this.handleUploadProgress(event, idTypeA)
    );
  }


  handleUploadProgress(event, idTypeA) {
    if (event.type === HttpEventType.DownloadProgress) {
      //this.uploadingProgressing = true
      //this.uploadProgress = Math.round(100 * event.loaded / event.total)
    }

    if (event.type === HttpEventType.UploadProgress) {
      if (idTypeA == 'DLfront') {
        this.dlFrontProgress = Math.round(100 * event.loaded / event.total)
      } else if (idTypeA == 'DLback') {
        this.dlbackProgress = Math.round(100 * event.loaded / event.total)
      } else if (idTypeA == 'idProof') {
        this.idproofProgress = Math.round(100 * event.loaded / event.total)
      }
    }

    if (event.type === HttpEventType.Response) {
      if (event.body.status == true) {
        this.intilizeComponent(event.body.customer)
        console.log("uploaded suscessfully");
      } else if (event.body.status == false) {
        console.log("uploaded failed! Try Again.");
      }
      //console.log(event.body)
    }
  }
  // end of doucment upload
  //_____.._________________________________________________________________________________________



  //_______________________________________________________________________________________________
  // Start of Payment module 
  //_______________________________________________________________________________________________

  referralMsg: string = ""; // to show the error msg in self pickup promo code apply
  //referralMsg1: string = ""; // to show the error msg in home delivery promo code apply
  referralCodeT: string = "";
  refferedCustomerId: string = "";
  //referralCodeT1: string = "";

  // test promo code dee8899d
  applyReferal(referralCode) {
    //"/validatePromoCode"
    if (this.debugData) {
      console.log("Clicked on apply referal");
    }
    this.referralMsg = "Please wait....";
    if ((referralCode != "") && (this.checkUserLoginStatus() == true)) {
      let referralData = {
        id: this.user.id,
        referalCode: referralCode
      }
      if (this.debugData) {
        console.log("Referral data:");
        console.log(referralData);
      }
      this.httpClient.post(this.apiService.validateReferralURL, referralData)
        .subscribe(
          (dataReferal: any) => {
            if (this.debugData) {
              console.log("signup form function api data");
              console.log(dataReferal);
            }
            if (dataReferal.status == 1) {
              this.refferedCustomerId = dataReferal.refferedCustomerId;
              this.referralCodeT = referralCode;
              this.usePromoCode = true;
              this.referralMsg = "Referal code applied sucessfully";
            } else if (dataReferal.status == 2) {
              this.refferedCustomerId = "";
              this.referralCodeT = '';
              this.usePromoCode = false;
              this.referralMsg = "You already used the Promo Code";
            } else {
              this.refferedCustomerId = "";
              this.referralCodeT = '';
              this.usePromoCode = false;
              this.referralMsg = "Invalid Referral code";
            }
          },
          (err) => {
            if (this.debugData) {
              console.log("Some error occured while parsing data from url");
            }
            this.refferedCustomerId = "";
            this.referralCodeT = '';
            this.usePromoCode = false;
            this.referralMsg = "Some erroe occured, while applying referal code. Plz try again.";
          });
    } else {
      if (this.debugData) {
        console.log("Refferal code not applied- user not logged in or referral code is null");
      }
      this.refferedCustomerId = "";
      this.referralCodeT = '';
      this.usePromoCode = false;
      this.referralMsg = "Please Enter a valid referal code";
    }

  }

  removeReferal() {
    this.referralCodeT = '';
    this.usePromoCode = false;
    this.referralMsg = "Referal code removed";
  }

  getCustomerPoints() {
    let dataToPost = { id: this.user.id }
    this.httpClient.post(this.apiService.getCustomerPoints, dataToPost)
      .subscribe(
        (dataPoint: any) => {
          if (this.debugData) {
            console.log("Customer get Point API data");
            console.log(dataPoint);
          }
          this.availablePoints = dataPoint.points;
          //availablePoints
        },
        (err) => {
          if (this.debugData) {
            console.log("Some error occured while parsing data from url");
          }
        });
  }

  applyPoints(val) {
    this.usePoints = !this.usePoints;
    console.log(this.usePoints);
  }

  tabSelectedReferalPoint(valueTab) {
    this.referalAndPointTabPos = valueTab.index;
    if (this.debugData) {
      console.log(valueTab);
    }
  }

  getTotalPrice() {
    let modelPriceTemp: number = this.modelDataOriginal[0].price;
    let tempTotalPrice: number = 0;
    if (this.extraHelmetType == 1) {
      tempTotalPrice += 50;
    }
    if (this.bookingDeliveryType == 1) {
      tempTotalPrice += 300;
    }
    // if (this.usePoints == true){
    //   this.totalPyamentPrice = tempTotalPrice + modelPriceTemp;
    //   this.totalPyamentPrice = 
    // }else{ 
    //   this.totalPyamentPrice = tempTotalPrice + modelPriceTemp;
    // }
    this.totalPyamentPrice = tempTotalPrice + modelPriceTemp + this.user.penaltyCharge + this.finalAmount;
   // console.log(tempTotalPrice + modelPriceTemp + this.user.penaltyCharge + this.finalAmount);
    //console.log(this.finalAmount);
    return this.totalPyamentPrice;
  }

  ongoingDataTemp: Array<any> = [];
  initiatePaymentFun(BookingType: number, event: any) {

    if (this.debugData) {
      console.log("OnGoing FUnction : ");
    }
    let getData = { "customer": this.user.id }
    this.httpClient.post(this.apiService.ongoingBooking, getData)
      .subscribe(
        (jdetail: any) => {
          if (this.debugData) {
            console.log("OnGoing API Data: ");
            console.log(jdetail);
          }
          this.ongoingDataTemp = jdetail;

          if (this.ongoingDataTemp.length != 0) {
            //this.error("You already have a ongoing booking, You can't book another.");
            this.ongoingErrorMsg = "You already have a ongoing booking, You can't book another.";
            this.ongoingError.show();
          } else {
            this.initiatePaymentFunProceed(BookingType);
          }
        }
      )
  }




  totalPyamentPrice: number = 0; // the price that user needs to pay (Final amount)
  paymentGatewayData: any = {}; // whole data object to be sent to the payment gateway server
  selectedLoaction: string = ""; // to show the selected location into ui field of pickup location
  selectedPickUpLocationId: number = 0; //to store the id of the pickup location to pass into api 
  bookingDeliveryType: number = 0; // to get to know the booking delivery type - 0 or 1
  extraHelmetType: number = 0; // to store and read the values of extra helmet from ui and other function
  usePoints: boolean = false; // to know the status of use points
  usePromoCode: boolean = false; // to know and store if someone choosed for apply promo code
  referalAndPointTabPos: number = 0; // to hold and store the current selected tab of referral and points tab.
  pickup_location_msg: string = ""; // to show pickup location error message
  booking_error_msg: string = ""; //to show if alredy ongoing booking is there

  initiatePaymentFunProceed(BookingType: number) {
    let selfPickUp = true;
    let bookingObj: any = {}; // to store the booking object to be sent in payment gateway
    let subscriptionObj: any = {}; // to store the subscrption object in case of subscription type
    let udfObj: any = {}; // to store the udfObjec to be sent to the payment gateway
    let finalObject: any = {}; // to store the final values to be sent in the server

    let helmetCharge: number = 0; // to store the price of helmet 
    let deliveryCharge: number = 0;
    let isSubscriptionChoosed: number = 0;


    let hh = this.getTotalPrice(); // just to confirm the price

    // if subscrption choosed
    if (this.selectedMonthsVal == 1) {
      isSubscriptionChoosed = 0;
    } else {
      isSubscriptionChoosed = 1;
    }
    //if extra helmet choosed
    if (this.extraHelmetType == 1) {
      helmetCharge = 50;
    } else {
      helmetCharge = 0;
    }
    // if delivery type choosed
    if (this.bookingDeliveryType == 1) {
      deliveryCharge = 300;
      selfPickUp = false;
    } else if (this.bookingDeliveryType == 0) {
      deliveryCharge = 0;
      selfPickUp = true;
    }


    if (this.usePoints == true) {
      let pointsToRedeems = 0;
      let ttPrice = this.modelDataOriginal[0].price;
      ttPrice += helmetCharge;
      ttPrice += deliveryCharge;
      if (this.availablePoints >= ttPrice) {
        pointsToRedeems = ttPrice;
      } else {
        pointsToRedeems = this.availablePoints;
      }
      udfObj = {
        udf1: 'points',
        udf2: this.user.id,
        //udf3: total < 1 ? modelPrice : vm.customerPoints
        udf3: pointsToRedeems
      };
    }
    else if (this.usePromoCode == true) {
      udfObj = {
        udf1: 'referal',
        udf2: this.user.id,
        udf3: this.refferedCustomerId
      };
    }
    else {
      udfObj = {
        udf1: 'normal',
        udf2: this.user.id,
        udf3: 0
      };
    }

    let finalAmountToPay = this.getTotalPrice();
    if (this.usePoints == true && this.availablePoints != 0) {
      if (this.availablePoints >= finalAmountToPay) {
        this.totalPyamentPrice = 0;
      } else {
        this.totalPyamentPrice = finalAmountToPay - this.availablePoints;
      }
    }

    if (BookingType == 1) {
      // home delivery
      let addressHOmeDel = (<HTMLInputElement>document.getElementById('addressDel')).value; // to get the value from html text field
      let cityHOmeDel = (<HTMLInputElement>document.getElementById('cityUserDel')).value; // to get the values of delivery city from html
      let pinHOmeDel = (<HTMLInputElement>document.getElementById('pinUserDel')).value; // to get the value of delivery pincode from html
      let fullAddress = addressHOmeDel + ", " + cityHOmeDel + ", " + pinHOmeDel;

      if (addressHOmeDel == '' || addressHOmeDel == null || cityHOmeDel == '' || cityHOmeDel == null || pinHOmeDel == '' || pinHOmeDel == null) {
        this.error("Please fill up valid delivery location.");
        return;
      }

      bookingObj = {
        customer: this.user.id,
        model: this.modelDataOriginal[0].id,
        productInfo: this.modelDataOriginal[0].name,
        extraHelmet: this.extraHelmetType,   //1 for true , 0 for false
        deliveryType: this.bookingDeliveryType,   //1 is for home , 0 is for self pickup
        deliveryAddress: fullAddress, // in case of home delevery
        rentalCharge: this.modelDataOriginal[0].price,  //price of bike
        deliveryCharge: deliveryCharge,
        helmetCharge: helmetCharge,
        penaltyCharge: this.user.penaltyCharge , 
        isSubscription: isSubscriptionChoosed,
        source: "web"
      };

      if (isSubscriptionChoosed == 1) {
        subscriptionObj = {
          totalMonths: this.selectedMonths,
          selectedMonths: this.selectedMonths,
          extendedMonths: 0
        };


        finalObject = {
          'bookingObj': bookingObj,
          'subscriptionObj': subscriptionObj,
          'udf': udfObj,
          'amount': this.totalPyamentPrice
        };
      } else {
        finalObject = {
          'bookingObj': bookingObj,
          'udf': udfObj,
          'amount': this.totalPyamentPrice
        };
      }

      if (this.debugData) {
        console.log("Home Delivery - payment Object sent to server");
        console.log(finalObject);
      }
      // calling payment gateway to initiate the payment module
      this.gotoPaymentGateway(finalObject);
    } else {
      if (this.selectedPickUpLocationId == 0) {
        // this.error("Please select valid pickup location.");
        this.pickup_location_msg = "Please select valid pickup location.";
        return;
      }
      bookingObj = {
        customer: this.user.id,
        model: this.modelDataOriginal[0].id,
        productInfo: this.modelDataOriginal[0].name,
        extraHelmet: this.extraHelmetType,   //1 for true , 0 for false
        deliveryType: this.bookingDeliveryType,    //1 is for home , 0 is for self pickup
        pickUpLocation: this.selectedPickUpLocationId,
        rentalCharge: this.modelDataOriginal[0].price,  //price of bike
        helmetCharge: helmetCharge,
        penaltyCharge: this.user.penaltyCharge,
        isSubscription: isSubscriptionChoosed,
        source: "web"
      };

      if (isSubscriptionChoosed == 1) {
        subscriptionObj = {
          totalMonths: this.selectedMonths,
          selectedMonths: this.selectedMonths,
          extendedMonths: 0
        }
        finalObject = {
          'bookingObj': bookingObj,
          'subscriptionObj': subscriptionObj,
          'udf': udfObj,
          'amount': this.totalPyamentPrice
        };
      } else {
        finalObject = {
          'bookingObj': bookingObj,
          'udf': udfObj,
          'amount': this.totalPyamentPrice
        };
      }

      if (this.debugData) {
        console.log("Self Pickup - payment Object sent to server");
        console.log(finalObject);
      }
      // calling payment gateway to initiate the payment module
      this.gotoPaymentGateway(finalObject);
    }
  }

  // function to send the parms to the payment gateway for initiate payment
  gotoPaymentGateway(objectToPost) {
    this.httpClient.post(this.apiService.initiatePaymentURL, objectToPost)
      .subscribe(
        (paymentData: any) => {
          if (this.debugData) {
            console.log("Initiate Payment API Data");
            console.log(paymentData);
          }

          if (paymentData.status == 1) {
            this.paymentGatewayData = paymentData.obj;
            this.paymentGatewayData.surl = this.baseUrl + "/api/paymentResponse";
            this.paymentGatewayData.furl = this.baseUrl + "/api/paymentResponse";

            this.paymentGatewayData.service_provider = "";

            if (this.debugData) {
              console.log("payment gateway object");
              console.log(this.paymentGatewayData);
            }

            if (this.paymentGatewayData.amount == 0) {
              if (this.debugData) {
                console.log("you are elizible for free booking");
              }
              //this.goToDirectBookingGateway(this.paymentGatewayData);
              this.paymentGatewayProceedDirect.show();
            } else {
              this.paymentGatewayProceed.show();
            }
          } else {
            //console.log("Some Error Occured, You have ongoing booking ");
            this.booking_error_msg = "Please Verify Your Mobile Number";
          }
        },
        (err) => {
          if (this.debugData) {
            console.log("Some error occured while parsing data from url");
          }
        });
  }

  //<!-- Start of direct payment using points  -->
  goToDirectBookingGateway() {
    let paymentGatewayData = this.paymentGatewayData;
    let time = new Date();
    let mpayIdd = time.getTime();
    let paymentGatewayDataForDirect: any = {};
    paymentGatewayDataForDirect = {
      "mihpayid": mpayIdd, // unix timestamp add functions
      "status": "success",
      "txnid": paymentGatewayData.txnid,
      "udf1": paymentGatewayData.udf1,
      "udf2": paymentGatewayData.udf2,
      "udf3": paymentGatewayData.udf3,
      "udf4": paymentGatewayData.udf4,
      "amount": paymentGatewayData.amount
    };
    if (this.debugData) {
      console.log("Direct response Function ");
    }
    this.httpClient.post(this.apiService.paymentResponseURL, paymentGatewayDataForDirect)
      .subscribe(
        (pmtdetail: any) => {
          if (this.debugData) {
            console.log("Payment Response API Data: ");
            console.log(pmtdetail);
          }
          if (pmtdetail.status = 1) {
            console.log(pmtdetail.paymentId);
          }
        }
      )
      
  }
  //<!-- End of direct payment using points  -->


  // to save and apply the delivery type choosed by the user - Home Or Self
  deliveryModeApply(deliveryType: number) {
    if (this.debugData) {
      console.log("Delivery Mode function");
    }
    if (deliveryType == 0) {
      this.bookingDeliveryType = 0;
      if (this.debugData) {
        console.log("Delivery Mode - Self");
        console.log(this.bookingDeliveryType);
      }
    } else if (deliveryType == 1) {
      this.bookingDeliveryType = 1;
      if (this.debugData) {
        console.log("Delivery Mode - Home");
        console.log(this.bookingDeliveryType);
      }
    }
    this.getTotalPrice();
  }
  // to apply and store extra helmet requirement by user
  extraHelmetApply(extraHel) {
    if (this.debugData) {
      console.log("Extra helmet Function Data");
      console.log(extraHel);
    }
    if (extraHel == 0) {
      this.extraHelmetType = 0;
    } else if (extraHel == 1) {
      this.extraHelmetType = 1;
    }
    this.getTotalPrice();
  }

  // to apply the pickup location choosed by the user
  pickUpLocationApply(locationID) {
    this.selectedPickUpLocationId = locationID;
    if (this.debugData) {
      console.log("Pickup Location Function, Customer choose Location Id: ")
      console.log(locationID);
    }
    for (let i = 0; i < this.location.length; i++) {
      if (this.location[i].id == locationID) {
        this.selectedLoaction = this.location[i].address;
        break;
      }
    }
    this.getTotalPrice();
  }

  sameDeliveryAddress() {
    (<HTMLInputElement>document.getElementById('addressDel')).value = this.user.address;
    (<HTMLInputElement>document.getElementById('cityUserDel')).value = this.user.city;
    (<HTMLInputElement>document.getElementById('pinUserDel')).value = String(this.user.pinCode);
  }



  //ongoing data for penalty charge
  // getOngoing() {
  //   let penaltyCharge: number = 0; // to store the penalty charge 
  //   if (this.debugData) {
  //     console.log("OnGoing FUnction : ");
  //   }
  //   let getData = { "customer": this.user.id }
  //   this.httpClient.post(this.apiService.ongoingBooking, getData)
  //     .subscribe(
  //       (jdetail: any) => {

  //         if (this.debugData) {
  //           console.log("OnGoing API Data: ");
  //           console.log(jdetail);
  //         }
  //         this.ongoingData = jdetail;
  //         this.user[0].penaltyCharge=jdetail.penaltyCharge;
  //         console.log(this.ongoingData[0].penaltyCharge);
  //         console.log(this.user[0].penaltyCharge);
  //         penaltyCharge=this.ongoingData[0].penaltyCharge;
  //         console.log(penaltyCharge);
  //       }
  //     )
  // }

  

}
  //_______________________________________________________________________________________________
  // End of Payment module 
  //_______________________________________________________________________________________________




//document.forms["payuform"].submit();
              //var myForm = <HTMLFormElement>document.getElementById('payuform');
              //myForm.submit();
              //document.forms["payuform"].submit();
              // amount: 3014
              // email: "sau@gmail.com"
              // firstname: "sau"
              // hash: "e1372dae2564b98729033ef49b13d92deb7a286c21e3b4eef1a8c073078aea767e61e5b73a060847e5054d657d311a4d67f2ba2cf0c2fba58e9d8da7ca69868e"
              // key: "gtKFFx"
              // phone: "8389952020"
              // productinfo: "TVS Sport"
              // salt: "eCwWELxi"
              // txnid: "L18G3993"
              // udf1: "normal"
              // udf2: 6848
              // udf3: 0
              // url: "https://test.payu.in/_payment"


// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/bike-selection/bike-selection.component.ts